export class UppercaseMask {
  static transform(value: string | null) {
    return (value || '').toUpperCase();
  }
}